import { DeepPartial } from "react-hook-form";
import { AavoFormLayout } from "src/components/common/forms/AavoFormLayout.tsx";
import { useAavoWizardStepForm } from "src/components/common/wizard/useAavoWizardStepForm.ts";
import {
	CustomerFormContent,
	CustomerFormValues,
} from "src/components/views/erp/sales/customer/CustomerFormContent.tsx";
import { SalesLeadToOfferApi_InitData } from "src/api/generated/erp/sales/crm/salesLeads/api/salesLeadToOfferApi.ts";
import { DEFAULT_COUNTRY_CODE } from "src/components/common/country/countries.ts";
import { getCustomerContactsFromSalesLeadContacts } from "src/components/views/erp/sales/crm/salesLeadToOffer/SalesLeadToOfferWizard.utils.ts";

interface CustomerFormWizardStepProps {
	initData: SalesLeadToOfferApi_InitData;
	defaultValues: DeepPartial<CustomerFormValues>;
	onUpdate: (values: DeepPartial<CustomerFormValues>) => void;
}

export const CustomerWizardStep = ({ initData, defaultValues, onUpdate }: CustomerFormWizardStepProps) => {
	const useAavoFormReturn = useAavoWizardStepForm<CustomerFormValues>({
		defaultValues,
		onUpdate,
	});

	return (
		<AavoFormLayout columns={2}>
			<CustomerFormContent {...useAavoFormReturn} isNewRecord={true} initData={initData} />
		</AavoFormLayout>
	);
};

export function getDefaultCustomerValues(initData: SalesLeadToOfferApi_InitData): DeepPartial<CustomerFormValues> {
	const salesLead = initData.salesLead;
	// Contacts are ordered with the primary contact first.
	const primaryContact = initData.salesLeadContacts[0];
	return {
		customerName: salesLead.customerName,
		customerType: salesLead.customerType,
		customerGroupId: salesLead.customerGroupId,
		salespersonId: salesLead.salespersonId,
		language: "FINNISH",
		invoiceChannel: "EMAIL",
		discountPercentage: 0,
		currencyId: initData.currencyOptions.find((currency) => currency.currencyCode === "EUR")?.currencyId,
		invoiceSameAsDelivery: false,
		paymentTermId: initData.paymentTermOptions.find((term) => term.isDefault)?.paymentTermId,
		deliveryAddress: {
			address_1: salesLead.address_1,
			address_2: salesLead.address_2,
			postalCode: salesLead.postalCode,
			city: salesLead.city,
			country: salesLead.country ?? DEFAULT_COUNTRY_CODE,
			phone: primaryContact?.phone ?? "",
			email: primaryContact?.email ?? "",
		},
		invoiceAddress: {
			country: DEFAULT_COUNTRY_CODE,
			phone: "",
			email: "",
		},
		...getCustomerContactsFromSalesLeadContacts(initData.salesLeadContacts),
	};
}
